// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/apps/upload_csv_chunk" endpoint
 */
import { featureOn } from "@lib/featureFlipper";
import type { FetchOptions } from "@lib/fetch";
import fetch, { fetchWithRetry } from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUploadCsvChunkCacheKeys } from "./constants";
import type { PostAppsUploadCsvChunkProps, UploadCsvChunkResult } from "./types";

export const postUploadCsvChunk = reactQueryMutationAdapter(
  appsUploadCsvChunkCacheKeys,
  (props: PostAppsUploadCsvChunkProps): Promise<UploadCsvChunkResult> => {
    const formData = new FormData();
    formData.append("csv_file", props.csv_file);
    formData.append("import_id", props.import_id);

    const headers = {};
    if (props.offset !== undefined && props.total_size !== undefined) {
      headers["Content-Range"] = `bytes ${props.offset}-${props.offset + props.csv_file.size}/${props.total_size}`;
    }

    const options: FetchOptions = {
      body: formData,
      headers,
      signal: props.signal,
    };
    // We need `setContentType: false` so that brazeFetch does not set the Content-Type header to application/json. We do
    // not want to explicitly set that header when using FormData.
    const settings = { setContentType: false, propagateFetchRequestError: false };
    const fetcher = featureOn("csv_import_chunk_retry")
      ? fetchWithRetry({ maxAttempts: 3, retryDelay: 1000, expBackoff: true })
      : fetch;
    return fetcher("/apps/upload_csv_chunk", "POST", {}, options, settings);
  }
);
